import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "info", "reportMonth", "totalHours", "calculatedAmount"]

  connect() {
    this.update()
  }

  update() {
    const select = this.selectTarget
    const selectedOption = select.options[select.selectedIndex]

    if (selectedOption && selectedOption.value) {
      this.infoTarget.classList.remove("hidden")
      this.reportMonthTarget.textContent = selectedOption.dataset.reportMonth || "-"
      this.totalHoursTarget.textContent = selectedOption.dataset.totalHours || "-"
      this.calculatedAmountTarget.textContent = selectedOption.dataset.calculatedAmount || "\u00A50"
    } else {
      this.infoTarget.classList.add("hidden")
    }
  }
}
